<script>
  import { toastStore } from 'stores/toast'
  import iconSuccess from 'assets/imgs/toast/icon-success.svg'
  import iconError from 'assets/imgs/toast/icon-error.svg'
  import iconAlert from 'assets/imgs/toast/icon-alert.svg'

  /**
   * @typedef {Object} Props
   * @property {string} [dataCy]
   */

  /** @type {Props} */
  let { dataCy = '' } = $props();

  function removeToast(id) {
    toastStore.destroyToast(id)
  }

  function toastBarIcon(type) {
    switch (type) {
      case 'success':
        return { icon: iconSuccess }
      case 'error':
        return { icon: iconError }
      case 'alert':
        return { icon: iconAlert }
      default:
        return { icon: iconAlert }
    }
  }
</script>

<style>
  .toast-container {
    position: fixed;
    top: 1em;
    right: 1em;
    z-index: 999;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .toast {
    background-color: white;
    margin-bottom: 1em;
    border-radius: 4px;
    border-width: 1px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    padding: 20px;
    font-size: 16px;
    max-width: 600px;
  }

  .toast.error {
    background-color: #fee4e2;
    border-color: #f0aba6;
    color: #b1180d;
  }

  .toast.success {
    background-color: #d1fadf;
    border-color: #9dddbf;
    color: #046c4e;
  }
  .toast.alert {
    background-color: #fff1c9;
    border-color: #ffe493;
    color: #815505;
  }

  .toast-title {
    display: flex;
    align-items: flex-start;
  }
  .text-title {
    padding-right: 10px;
  }
  .toast-title {
    font-weight: bold;
  }

  p {
    margin: 0;
    flex-grow: 1;
  }

  .close {
    background: none;
    border: none;
    color: #77777a;
    cursor: pointer;
    margin-left: 10px;
    margin-right: 10px;
    right: 0px;
    position: absolute;
  }
  .toast-icon {
    background: none;
    display: inline-block;
  }
</style>

<div class="toast-container" data-cy={dataCy}>
  {#each $toastStore as toast}
    <div class="toast {toast.type}">
      <div class="toast-title">
        <img alt="toast-icon" class={`mt-1 toast-icon mr-1`} src={toastBarIcon(toast.type)?.icon} data-cy={`icon-toast-${toast.type}`} />
        <div data-cy="toast-title-text" class="text-title" style=" word-break: break-word;">{toast.message}</div>
        <button class="close" onclick={() => removeToast(toast.id)} data-cy="close-toast-message">&times;</button>
      </div>
      <div>{toast.description}</div>
    </div>
  {/each}
</div>
